import InternalCheckbox from './Checkbox';
import Group from './Group';
export { CheckboxProps, CheckboxChangeEvent } from './Checkbox';
export { CheckboxGroupProps, CheckboxOptionType } from './Group';
const Checkbox = InternalCheckbox;
Checkbox.Group = Group;
Checkbox.__ANT_CHECKBOX = true;
export default Checkbox;
